import React, { Component } from 'react';
import CONNECT from '../../../../redux/connect';
import Body from '../../../reuseable/Body';
import Header from '../../../reuseable/Header';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount() {

    }
    render() {
        return (
            <>
                <Header {...this.props} />
                <Body {...this.props} />
            </>
        )
    }
}
export default CONNECT(Profile);